import translate from './translations';

/**
 * Prevents login form submission if inputs are invalid so that a page does not refresh unnecessarily.
 * @param {Object} elemObj An object of DOM elements.
 * @param {Element} elemObj.errorPanelBackend
 * @param {Element} elemObj.errorPanelFrontend
 * @param {Element} elemObj.form
 */
function loginFormSubmission({ errorPanelBackend, errorPanelFrontend, form }) {
    if (!errorPanelBackend || !errorPanelFrontend || !form) {
        return;
    }

    const inputEmail = form.querySelector('input[name=email]');
    const inputPassword = form.querySelector('input[name=password]');
    const invalidClass = 'is-invalid';

    const pushErrorMessage = (text) => {
        const errorElem = document.createElement('div');
        errorElem.className = 'message-panel error';
        errorElem.textContent = translate(text);
        errorPanelFrontend.appendChild(errorElem);
    }

    form.addEventListener('submit', (event) => {
        // Clear the error panels
        errorPanelBackend.textContent = '';
        errorPanelFrontend.textContent = '';

        if (!inputEmail.value) {
            event.preventDefault();
            pushErrorMessage('frontend_js.validation.email.required');
        } else if (inputEmail.classList.contains(invalidClass) || inputEmail.value === '@') {
            event.preventDefault();
            pushErrorMessage('frontend_js.validation.email.incorrect');
        }

        if (!inputPassword.value) {
            event.preventDefault();
            pushErrorMessage('frontend_js.validation.password.required');
        }
    });
}

// For login modal
loginFormSubmission({
    errorPanelBackend: document.querySelector('.js-login-modal-errors-panel-backend'),
    errorPanelFrontend: document.querySelector('.js-login-modal-errors-panel-frontend'),
    form: document.querySelector('.js-login-modal-form')
});

// For login page
loginFormSubmission({
    errorPanelBackend: document.querySelector('.js-login-page-errors-and-messages-panel-backend'),
    errorPanelFrontend: document.querySelector('.js-login-page-errors-panel-frontend'),
    form: document.querySelector('.js-login-page-form')
});
